module.exports = __webpack_public_path__ + "img/fondosection.92bffc8c.jpg";